import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  isLoggedIn: JSON.parse(localStorage.getItem("isLoggedIn")) || false,
  loginError: null,
  accessToken: localStorage.getItem("accessToken") || null,
  loginTime: localStorage.getItem("loginTime") || null,
  isLoading: false,
};
const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      const currentTime = Date.now();
      state.isLoggedIn = true;
      state.loginError = null;
      state.accessToken = action.payload.accessToken;
      state.loginTime = currentTime; 
      localStorage.setItem("isLoggedIn", true);
      localStorage.setItem("accessToken", action.payload.accessToken);
      localStorage.setItem("loginTime", currentTime);
    },
    logout: (state) => {
      state.isLoggedIn = false;
      state.accessToken = null;
      state.loginError = null;
      state.isLoading = false;
      localStorage.removeItem("isLoggedIn");
      localStorage.removeItem("accessToken");
      localStorage.removeItem("loginTime");
      localStorage.clear();
    },
    setLoginError: (state, action) => {
      state.loginError = action.payload;
    },
    clearLoginError: (state) => {
      state.loginError = null;
    },
  },
});
export const { loginSuccess, logout, setLoginError, clearLoginError, showLoading, hideLoading } = authSlice.actions;
export default authSlice.reducer;